import './css/index.css'
import Install1 from './pages/SystemSetting_one'
import Install3 from './pages/SystemSetting_third'
import Install2 from './pages/SystemSetting_two'

export default {
  name: 'iot.guide',
  routers: {
    '/': [
      {
        path: 'systemSettingOne',
        component: props => <Install1 type="front" />
      },
      {
        path: 'systemSettingTwo',
        component: Install2
      },
      {
        path: 'systemSettingThird',
        component: props => <Install3 type="front" />
      }
    ]
  }
}
